/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterPrice_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuPriceRanges_user">;
    readonly " $refType": "SbMobileRefineMenuFilterPrice_user";
};
export type SbMobileRefineMenuFilterPrice_user$data = SbMobileRefineMenuFilterPrice_user;
export type SbMobileRefineMenuFilterPrice_user$key = {
    readonly " $data"?: SbMobileRefineMenuFilterPrice_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterPrice_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbMobileRefineMenuFilterPrice_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '77f01d41e43e052c219d3b8138861868';
export default node;
